import { GlobalStoresProvider } from 'es/app/store/GlobalStore';
import React, { ErrorInfo } from 'react';
import LogManager from 'es/core/logging/LogManager';
import { ErrorBoundary } from 'react-error-boundary';
import UnexpectedError from 'es/app/components/error/UnexpectedError';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ROUTES } from 'es/app/components/layout/Routes';
import { ThemeProvider } from 'es/app/theme';
import { OverlaysProvider } from '@blueprintjs/core';

import 'mapbox-gl/dist/mapbox-gl.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/datetime/lib/css/blueprint-datetime.css';

import './visuals/styles/reset.scss';
import './visuals/styles/toolkit.scss';

const logger = LogManager.getLogger('App');

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

const router = createBrowserRouter(ROUTES);

const App = React.memo(() => {
    const handleError = (error: Error, info: ErrorInfo) => {
        logger.error(error.message, error.name, error.stack, info.componentStack);
    };

    return (
        <ThemeProvider>
            <OverlaysProvider>
                <ErrorBoundary onError={handleError} FallbackComponent={UnexpectedError}>
                    <QueryClientProvider client={queryClient}>
                        <GlobalStoresProvider>
                            <RouterProvider router={router} />
                        </GlobalStoresProvider>
                    </QueryClientProvider>
                </ErrorBoundary>
            </OverlaysProvider>
        </ThemeProvider>
    );
});

export default App;
